import { type TComment as TApiComment } from '@core/api'

import { type TComment } from '@core/models'

import { convertCommenter } from './convertCommenter'
import { convertReply } from './convertReply'

export const convertComment = (apiComment: TApiComment): TComment => {
    const {
        commenter,
        content,
        date_created,
        date_deleted,
        date_updated,
        id,
        replies,
        replies_count,
        thread_count,
        time,
    } = apiComment

    return {
        commenter: convertCommenter(commenter),
        content,
        dateCreated: date_created,
        dateDeleted: date_deleted,
        dateUpdated: date_updated,
        id,
        threadId: id,
        replies: replies?.map(apiReply => convertReply(apiReply)) ?? [],
        repliesCount: replies_count,
        threadCount: thread_count,
        timeInSeconds: time,
    }
}
